import {getResourceFile} from '../network';

export const productImagePreview = product => {
    let src = null;
    if (product.media && product.media.length) {
        for (let i = 0; i < product.media.length; i++) {
            if (product.media[i].type === 'image') {
                src = getResourceFile(product.media[i].resource);
                break;
            }
        }
    }

    if (!src) {
        if (product.variants && product.variants.length) {
            for (let i = 0; i < product.variants.length; i++) {
                const variant = product.variants[i];
                for (let i = 0; i < variant.media.length; i++) {
                    if (variant.media[i].type === 'image') {
                        src = getResourceFile(variant.media[i].resource);
                        break;
                    }
                }
            }
        }
    }

    return src;
};
